class PlanAmount {
  constructor(private readonly _value: number = NaN) {
  }

  public isEmpty() {
    return isNaN(this._value);
  }

  public toString(): string {
    return this.isEmpty() ? "" : this._value.toLocaleString("ja-JP");
  }

  public toNumber(): number {
    return this._value;
  }
}

export default PlanAmount;
